import { Toast } from "@/composables/toast";
export function getRedirectOnImportPath(response, isRunFormRedirect = false) {
    var _a, _b;
    if (isRunFormRedirect) {
        return { path: "/workflows/run", query: { id: response.id } };
    }
    else {
        if (response.status === "error") {
            Toast.error((_a = response.message) !== null && _a !== void 0 ? _a : "Import Failed");
        }
        else {
            Toast.success((_b = response.message) !== null && _b !== void 0 ? _b : "Import Successful");
        }
        return {
            path: "/workflows/list",
        };
    }
}
